<template>
  <div ref="box" class="maxwidht">
    <div class="bgcolor">
      <!-- 悬浮按钮 -->
      <div v-if="showFlag">
        <div class="buton2" @click="clickMe" v-if="showClickMe">点我下单 优先发货</div>

        <div class="showImg" :style="{ height: carouselHeight }">
          <img @mouseover="changeInterval(true)" @mouseleave="changeInterval(false)"
            v-for="(item, index) in carouselList" :key="index" :src="item" alt="暂无图片" v-show="index == currentIndex"
            ref="carouselImg">
          <div class="banner-circle">
            <ul>
              <li @click="changeImg(index2)" v-for="(item, index2) in carouselList" :key="index2"
                :class="index2 == currentIndex ? 'active' : ''"></li>
            </ul>
          </div>
        </div>
        <!-- 价格基本信息展示 -->
        <div class="baseInfo">
          <div class="flexMoney">
            <div>￥<span class="money">{{ currentObj.price }}起</span></div>
            <div>热卖5000+件</div>
          </div>
          <div class="desc">
            {{ currentObj.product_info_title }}
          </div>
          <!-- <div class="freeFlex">
              <div class="baoyou">包邮</div>
              <div class="freeFlex pay">
                <div class="cartDiv">
                  <img src="../assets/shopcart.png" alt="" class="cart">
                </div>
                <div class="">
                  验货满意后付款
                </div>
              </div>
            </div> -->
          <div class="service">
            服务
            <span><i class="el-icon-circle-check"></i>包邮</span>
            <span><i class="el-icon-circle-check"></i>假一赔三 </span>
            <span><i class="el-icon-circle-check"></i>七天退货</span>
            <br><span class="safeguard"><i class="el-icon-circle-check"></i>消费者服务保障</span>
          </div>
        </div>
        <!-- 滚动 -->
        <div class="commonstyle">
          <div class="scanNum">
            {{ people }}人正在浏览 <span>数量有限，先到先得</span>
          </div>
          <div class="sacnContainer">
            <vue-seamless-scroll :data="tableData" class="seamless-warp" :class-option="classOption">
              <div v-for="(item, index) in tableData" :key="index" class="table-body">
                <div class="unit">
                  <div>
                    <img :src="item.url" alt="" class="avatar">
                  </div>
                  <div class="personinfo">
                    <div class="namephone">{{ item.name }} {{ item.phone }}</div>
                    <div>
                      {{ currentObj.product_info_title }}
                    </div>
                  </div>
                  <div class="tobuy" @click="gotobottom">
                    马上抢
                  </div>
                </div>
              </div>
            </vue-seamless-scroll>
          </div>
        </div>
        <!-- 商品详情  售后切换 -->
        <div class="tabs">
          <div @click="changeTab1" :class="acitve ? 'activetab' : ''">商品详情</div>
          <div @click="changeTab2" :class="acitve ? '' : 'activetab'">咨询与售后</div>
        </div>
        <!-- 图文 -->
        <div v-if="acitve">
          <div class="pictext">
            一 图文详情 一
          </div>
          <div v-for="(item, index) in detailList" :key="index">
            <img :src="item" alt="" class="detailimg">
          </div>
        </div>
        <!-- 售后相关问题 -->
        <div v-else class="commonstyle">
          <el-collapse>
            <el-collapse-item title="●我的订单大概多久发货?" name="1" class="explaintitle">
              <div class="explaintext">
                订单的发货时间为您下单之后的72小时内，请您耐心等待。订单状态及物流运转进度可在订单详情中查看，
                普通地区异地物流运转时间3-5天左右，偏远地区异地物流运转时间5-7天左右，如遇特殊情况将会导致延误，
                以物流官网进度为准。若您的订单超出72小时仍未发货，建议您联系商家进行咨询。
              </div>
            </el-collapse-item>
            <el-collapse-item title="●我的订单如何申请换货? " name="2">
              <div class="explaintext">
                若您需办理换货，无需对订单进行任何操作，请您及时联系商家协商换货事宜，向商家索取商品寄回地址信息，
                将商品寄回至商家处，并向商家提供商品寄回有效物流单号，由商家为您安排换货。<br>
                换货要求：保证商品全新，不影响二次销售，商品包装完好，附件、赠品齐全。在寄回包裹中放置小纸条注明您
                的联系方式、订单号，禁止使用“到付”运费支付形式将商品寄回。
              </div>
            </el-collapse-item>
            <el-collapse-item title="●价格说明" name="3">
              <div class="explaintext">
                划线价格：指商品的专柜价，吊牌价，正品零售价，厂商指导价或该商品曾经展示的售卖价，并非原价，仅供参考。<br>
                未划线价格：指商品的实时标价，不因表述的差异改变性质。具体成交价格根据商品参加活动或者会员试用优惠券、
                积分等发生变化，最终以订单结算价格为准。
              </div>
            </el-collapse-item>
          </el-collapse>

        </div>
        <div ref="orderInfo">
          <!-- 订单相关 -->
          <div class="commonstyle">
            <div class="orderInfo">订单信息</div>
            <div class="border">
              <div class="padding orderFlex">
                <div>
                  <img :src="normImg ? normImg : currentObj.picture_src" alt="" class="orderimg">
                </div>
                <div class="orderMoney">
                  <div>
                    {{ normTitle ? normTitle : currentObj.product_info_title }}
                  </div>
                  <div class="red">
                    <div>￥<span class="money">{{ normPrice ? normPrice : currentObj.price }}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="paddingtb">
              {{ currentObj.product_info_title }}
            </div>
            <!-- 单规格样式 -->
            <div class=" border" v-if="currentObj.is_spesc==1 || !currentObj.is_spesc">
              <div v-for="(item, index) in normList" :key="index" class="normunit" @click="slectNorm(item)"
                :class="form.product_type_code == item.id ? 'activeradio' : 'deactiveradio'">
                套餐：{{ item.product_type_name }}
              </div>
            </div>
            <!-- 闭环 -->
            <!-- 多规格样式 -->
            <div class="paddingtb border" v-if="currentObj.is_spesc==2">
              <div v-for="(spec,specName) in sepcOptions" :key="specName">
                {{specName}}
                <div :class="[spec[0].main_image===1?'':'spec-container']">
                  <div
                    :class="['spec_item',option.main_image===1?'':'margin-right',option.is_selected?'sel_red':'',option.is_stock?'':'' ]"
                    v-for="option in spec" :key="option.id" @click="selectedSpec(option)">
                    <img v-if="option.spec_pic" :src="option.spec_pic" />
                    <div :class="option.main_image===1?'margin-left':'padding-sm'">{{option.value}}</div>
                    <div class="wu_huo" v-if="!option.is_stock">无货</div>
                  </div>
                </div>
              </div>

            </div>
            <div class="buynumflex paddingtb">
              <div class="buynum">购买数量</div>
              <div>
                <el-input-number v-model="form.order_num" :precision="0" :min="1" :max="100"
                  @change="changeNum"></el-input-number>
              </div>
            </div>
          </div>
          <!-- 个人信息表单 -->
          <div class="commonstyle">
            <el-form ref="form" :model="form" label-width="90px" label-position="left" :rules="rules">
              <el-form-item label="收货人" prop="receiver_name">
                <el-input v-model="form.receiver_name" placeholder="请输入收货人姓名" maxlength="6" />
              </el-form-item>
              <el-form-item label="联系方式" prop="receiver_tel">
                <el-input v-model="form.receiver_tel" placeholder="请输入11位手机号码" maxlength="11" />
              </el-form-item>
              <el-form-item label="所在区域" prop="receiver_area">
                <div style="width:100%">
                  <!-- <el-cascader style="width:100%" v-model="form.receiver_area" :options="options">
                  </el-cascader> -->
                  <div id="trigger4" style="margin-left: 16px;">
                    <span style="color: #C0C4CC;">请选择地区</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="详细地址" prop="receiver_address">
                <el-input v-model="form.receiver_address" placeholder="请输入详细地址" />
              </el-form-item>
            </el-form>
          </div>
          <!-- 支付方式 -->
          <div class="commonstyle">
            <div>支付方式</div>
            <!-- <div v-if="currentObj.pay_type == 1 || currentObj.pay_type == 2 || currentObj.pay_type == 3">
                <div v-if="currentObj.pay_type == 2 || currentObj.pay_type == 3" class="payflex"
                  @click="payTypeChange('wx_h5')">
                  <div class="paycontainer">
                    <div><img src="../assets/wxpay.png" alt="" class="payicon"></div>
                    <div>微信支付</div>
                  </div>
                  <div>
                    <el-radio v-model="form.pay_source" label="wx_h5"></el-radio>
                  </div>
                </div>
                <div v-if="currentObj.pay_type == 1 || currentObj.pay_type == 3" class="payflex"
                  @click="payTypeChange('alipay')">
                  <div class="paycontainer">
                    <div><img src="../assets/alipay.png" alt="" class="payicon"></div>
                    <div>支付宝支付</div>
                  </div>
                  <div>
                    <el-radio v-model="form.pay_source" label="alipay"></el-radio>
                  </div>
                </div>
              </div> -->
            <div v-if="this.currentObj.pay_type == 4">
              <div class="payflex" @click="payTypeChange('efps')">
                <div class="paycontainer">
                  <div><img src="../assets/wxpay.png" alt="" class="payicon"></div>
                  <div>微信支付</div>
                </div>
                <div>
                  <el-radio v-model="form.pay_source" label="efps"></el-radio>
                </div>
              </div>
              <div class="payflex" @click="payTypeChange('efpsalipay')">
                <div class="paycontainer">
                  <div><img src="../assets/alipay.png" alt="" class="payicon"></div>
                  <div>支付宝支付</div>
                </div>
                <div>
                  <el-radio v-model="form.pay_source" label="efpsalipay"></el-radio>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="this.currentObj.pay_type == 2 || this.currentObj.pay_type == 3" class="payflex"
                @click="payTypeChange('wx_xcx')">
                <div class="paycontainer">
                  <div><img src="../assets/wxpay.png" alt="" class="payicon"></div>
                  <div>微信支付</div>
                </div>
                <div>
                  <el-radio v-model="form.pay_source" label="wx_xcx"></el-radio>
                </div>
              </div>
              <div v-if="this.currentObj.pay_type == 1 || this.currentObj.pay_type == 3" class="payflex"
                @click="payTypeChange('alipay')">
                <div class="paycontainer">
                  <div><img src="../assets/alipay.png" alt="" class="payicon"></div>
                  <div>支付宝支付</div>
                </div>
                <div>
                  <el-radio v-model="form.pay_source" label="alipay"></el-radio>
                </div>
              </div>
            </div>

            <!-- <div class="payflex" v-if="currentObj.pay_type==2 || currentObj.pay_type==3">
                <div class="paycontainer">
                  <div><img src="../assets/wxpay.png" alt="" class="payicon"></div>
                  <div>微信支付</div>
                </div>
                <div>
                  <el-radio v-model="form.pay_source" label="efps"></el-radio>
                </div>
              </div>
              <div class="payflex" v-if="currentObj.pay_type==1 || currentObj.pay_type==3">
                <div class="paycontainer">
                  <div><img src="../assets/alipay.png" alt="" class="payicon"></div>
                  <div>支付宝支付</div>
                </div>
                <div>
                  <el-radio v-model="form.pay_source" label="alipay"></el-radio>
                </div>
              </div> -->

            <!-- <div class="payflex">
                <div class="paycontainer">
                  <div><img src="../assets/pay.png" alt="" class="payicon"></div>
                  <div>货到付款</div>
                </div>
                <div>
                  <span><i class="el-icon-circle-check red"></i></span>
                </div>
              </div> -->
          </div>
          <!-- 包邮实付款 -->
          <div class="commonstyle">
            <div class="flex conmonheight border">
              <div>运费</div>
              <div>包邮</div>
            </div>
            <div class="flex conmonheight border" v-if="useRedBag">
              <div>优惠券</div>
              <div>减{{ discountAmount }}</div>
            </div>
            <div class="flex conmonheight">
              <div>实付款</div>
              <div class="realPay">￥{{ form.order_total }}</div>
            </div>

          </div>
          <!-- 留言提交 -->
          <div class="commonstyle">
            <div class="messageflex">
              <div class="remark">买家留言</div>
              <div>
                <el-input v-model="form.order_notes" placeholder="选填：对快递等的特殊要求" maxlength="50" style="width:280px" />
              </div>
            </div>
            <el-button class="button" @click="submit" :disabled="buttonDisabled">
              立即抢购
            </el-button>
          </div>
        </div>
        <!-- <div class="wechat" @click="copyWchat">
          技术支持<img src="../assets/wechat.png">: jshnb2025
        </div> -->
      </div>
      <div v-else>
        <!-- <div><img :src="defaultImg" alt="" class="defaultImg"></div> -->
        <div v-for="(item, index) in defaultImg" :key="index" class="defaultImg">
          <img :src="item" alt="" class="detailimg">
        </div>
        <div v-if="defaultImg.length>0">
          <h2 class="text-center">立即获取更多信息</h2>
          <div class="text-center">
            <h4>请填写您的姓名和手机号，我们的团队将尽快与您取得联系</h4>
          </div>
          <div class="padding-xl">
            <div>
              <el-input v-model="psParams.name" placeholder="姓名"></el-input>
            </div>
            <div class="margin-top">
              <el-input v-model="psParams.phone" placeholder="手机号"></el-input>
            </div>
            <div class="margin-top">
              <el-checkbox v-model="psParams.checked">同意收集您的信息</el-checkbox>
            </div>
            <el-button class="margin-top" style="width: 100%;" type="primary" :disabled="!psParams.checked"
              @click="submitUserInfo">提交</el-button>
          </div>
        </div>
        <div class="center">{{ currentObj.company_info }}</div>

      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="70%" top="30vh" center :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="true">
      <div style="text-align: center;"><span style="font-size: 20px;">支付中</span>
        <div class="loading-dots"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="handlePaySuccess">我已支付</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import MobileDetect from "../utils/mobile.min.js";
  import {
    getIp,
    addOrder,
    getNotPddLanginPage,
    addOrderWX,
    getPayResult,
    getWXPayResult,
    setUserInfo
  } from "../utils/api"
  import citys from '../utils/city.json'
  import CryptoJS from "crypto-js";
  import PickerExtend from 'picker-extend'
  export default {
    data() {
      return {
        pass: false,
        mobileCode: null,
        servicePhone: null,
        buttonDisabled: false,
        dialogVisible: false,
        buttonText: '获取验证码',
        messageOpen: false,
        ipAddress: null,
        carouselHeight: '400px',
        useRedBag: false,
        discountAmount: 20,
        open: false,
        showHeight: null,
        showClickMe: true,
        disabled: false,
        aaa: true,
        loading: true,
        acitve: true,
        adminCity: '',
        classOption: {
          step: 0.5, // 数值越大速度滚动越快(默认1)
          limitMoveNum: 5, // 开启无缝滚动的数据量(默认5)
          hoverStop: false, // 是否开启鼠标悬停stop
          openTouch: false, // 移动端开启touch滑动
          direction: 1, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 2000, // 单步运动停止的时间(默认值1000ms)
        },
        tableData: [{
            id: 1,
            name: '张*星',
            phone: '182***78',
            url: require("../assets/p1.jpg")
          },
          {
            id: 2,
            name: '李*刚',
            phone: '139***32',
            url: require("../assets/p2.jpg")
          },
          {
            id: 3,
            name: '王*丫',
            phone: '158**88',
            url: require("../assets/p3.jpg")
          },
          {
            id: 4,
            name: '张*梅',
            phone: '131***56',
            url: require("../assets/p4.jpg")
          },
          {
            id: 5,
            name: '何*月',
            phone: '151***23',
            url: require("../assets/p5.jpg")
          },
        ],
        timer: null,
        people: null,
        currentObj: {},
        showFlag: false,
        carouselList: [],
        detailList: [],
        normList: [],
        normImg: null,
        normPrice: null,
        normTitle: null,
        form: {
          product_code: null,
          product_name: null,
          receiver_name: null,
          product_type_code: null,
          product_type_name: null,
          receiver_tel: null,
          receiver_area: null,
          receiver_address: null,
          order_num: null,
          order_price: null,
          order_total: null,
          order_notes: null,
          order_ip_address: null,
          landingpage_link: null,
          code_id: null,
          sign: null,
          os: null,
          click_Id: null,
          click_num: 0,
          source: 'index',
          channel: '',
          pay_source: 'efps',
          product_type_sku_img_url: '',
          csite: ''
        },
        currentIndex: 0,
        defaultImg: [],
        source: {
          1: 'alipay',
          2: 'wx_xcx',
          3: 'wx_xcx',
          4: 'efps'
        },
        rules: {
          receiver_name: [{
              required: true,
              message: "收货人姓名不能为空",
              trigger: "blur"
            },
            {
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: "请输入汉字",
              trigger: "blur"
            }
          ],
          receiver_area: [{
            required: true,
            message: "区域不能为空",
            trigger: "blur"
          }],
          receiver_address: [{
            required: true,
            message: "详细地址不能为空",
            trigger: "blur"
          }],
          receiver_tel: [{
              required: true,
              message: '手机号必填',
              trigger: 'blur'
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: '手机号码格式不正确',
              trigger: 'blur'
            }
          ]
        },
        options: citys,
        clickCount: 0,
        msgButton: false,
        timer: null, //定时轮询
        disabledIP: null,
        slefCity: null,
        is_open: false,
        payReuslt: null,
        tradeStatus: {
          'WAIT_BUYER_PAY': '等待买家付款',
          'TRADE_CLOSED': '未付款交易超时关闭',
          'TRADE_SUCCESS': '交易支付成功',
          'TRADE_FINISHED': '交易结束'
        },
        querySource: null,
        coupon: null,
        select_spec: [], //选中的规格id数组
        anyStock: true,
        psParams: {
          name: '',
          phone: '',
          checked: false
        }
      }
    },
    created() {
      this.init() //调用方法构造数据调用接口查询页面数据
      window.addEventListener("scroll", this.handleScrollx, true);
    },
    mounted() {
      let that = this;
      this.startInterval()
      setTimeout(() => {
        let clientH = window.innerHeight || document.documentElement.clientHeight;
        let boxHeight = this.$refs.box.offsetHeight
        let orderInfoHeight = 0
        if (this.$refs.orderInfo) {
          orderInfoHeight = this.$refs.orderInfo.offsetHeight
        }
        let showHeight = boxHeight - orderInfoHeight - clientH
        this.showHeight = showHeight

        var mobileSelect4 = new PickerExtend({
          trigger: "#trigger4",
          title: "地区选择器",
          wheels: [{
            data: citys
          }],
          position: [0, 0, 0],
          keyMap: {
            id: 'label',
            value: 'value',
            childs: 'children'
          },
          callback: function(indexArr, data) {

            that.form.receiver_area = [data[0].value, data[1].value, data[2] ? data[2].value : ''];
          }
        });

      }, 2000);
      // this.form.os=this.getSystem()
    },
    computed: {
      sepcOptions() {
        // 解析规格数据
        let newSpec = []
        return newSpec = this.currentObj.spec_info.reduce((acc, spec) => {
          if (!acc[spec.spec_name]) {
            acc[spec.spec_name] = [];
          }
          acc[spec.spec_name].push(spec);
          acc[spec.spec_name].sort((a, b) => b.main_image - a.main_image);

          return acc;
        }, {});

      },

    },
    methods: {
      //新表单
      submitUserInfo() {
        if (!this.psParams.name) {
          this.$message({
            type: 'error',
            message: '请输入姓名'
          });
          return
        }
        let regx = /^1(3\d|4[4-9]|5[0-35-9]|6|7[0-35-8]|8\d|9[0-35-9])\d{8}$/
        if (this.psParams.phone && !regx.test(this.psParams.phone)) {
          this.$message({
            type: 'error',
            message: '请填写正确手机号'
          });
          return
        }
        let codeId = this.getRequestParam()["code_id"]
        let parasm = {
          landingpagecode:codeId,
          name:this.psParams.name,
          telephone:this.psParams.phone
        }
        setUserInfo(parasm).then(res => {
          this.$confirm('我们会尽快与您取得联系', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type:'success'
          }).then(() => {

          }).catch(() => {

          });
        })
      },
      copyWchat() {

        const copyText = 'jshnb2025'
        console.log(!!navigator.clipboard)
        if (!navigator.clipboard) {
          // 创建一个临时的文本输入框
          const tempInput = document.createElement("textarea");
          tempInput.value = copyText;

          // 将输入框加入到页面中
          document.body.appendChild(tempInput);

          // 选中文本并复制
          tempInput.select();
          tempInput.setSelectionRange(0, 99999); // 对移动端设备的兼容处理
          document.execCommand("copy");

          // 移除临时输入框
          document.body.removeChild(tempInput);

          // 提示复制成功
          this.$message && this.$message.success ?
            this.$message.success("微信号复制成功") :
            alert("微信号复制成功");
        } else {
          navigator.clipboard.writeText(copyText);
          this.$message && this.$message.success ?
            this.$message.success("微信号复制成功") :
            alert("微信号复制成功");
        }

      },
      //选中行切换支付方式
      payTypeChange(type) {
        this.form.pay_source = type;
      },
      //首次赋值
      firstSpec() {

        let selGoods = this.currentObj.spec[0].spec_value_ids.split(',')
        this.select_spec = selGoods;
        this.updateSpec()
      },
      //更新选中与有货无货
      updateSpec() {
        this.currentObj.spec_info = this.currentObj.spec_info.map(ps => ({
          ...ps,
          is_stock: false,
          is_selected: false
        }))
        const specValueIds = this.currentObj.spec.flatMap(spec => spec.spec_value_ids.split(',').map(Number));

        const filteredAllSpecs = this.currentObj.spec_info.filter(spec => specValueIds.includes(spec.id) && spec
          .main_image === 1);

        filteredAllSpecs.forEach(item => {
          item.is_stock = true;
        })
        let wddd = this.currentObj.spec
          .filter((spec) => spec.spec_value_ids.includes(this.select_spec[0]))
        const specValueIdsSet = new Set();

        // 遍历 stockList，提取 spec_value_ids 字段
        wddd.forEach(item => {
          const ids = item.spec_value_ids.split(","); // 分割字符串为数组
          ids.forEach(id => specValueIdsSet.add(id)); // 将每个 ID 添加到 Set 中
        });
        // 将 Set 转换为数组并赋值给 uniqueSpecValueIds
        let uniqueSpecValueIds = Array.from(specValueIdsSet);
        //将已知的数组
        const extraSet = new Set(this.select_spec)
        let abc = uniqueSpecValueIds.filter(id => !extraSet.has(id));
        const specMap = this.currentObj.spec_info.reduce((map, item) => {
          map[item.id] = item;
          return map;
        }, {});
        //选中的规格遍历附加样式
        this.select_spec.forEach(id => {
          if (specMap[id]) {
            const result = uniqueSpecValueIds.includes(id);
            if (result) {
              specMap[id].is_selected = true;
              specMap[id].is_stock = true;
            } else {
              specMap[id].is_selected = true;
            }

          }
        });
        //添加有货样式
        abc.forEach(id => {
          if (specMap[id]) {
            specMap[id].is_stock = true;
          }
        });
        this.productSelection()
      },
      //选中
      selectedSpec(spec) {
        const existingIndex = this.select_spec.findIndex(id => {
          const existingItem = this.currentObj.spec_info.find(obj => obj.id === Number(id));
          return existingItem && existingItem.spec_name === spec.spec_name;
        });

        if (spec.main_image == 1) {
          // 如果选中的对象是主要的，则只保留当前选中的ID
          this.select_spec = [String(spec.id)];
        } else if (existingIndex !== -1) {
          // 如果类型相同，替换原来的ID
          this.select_spec.splice(existingIndex, 1, String(spec.id));
        } else {
          // 如果没有相同类型，直接添加ID
          this.select_spec.push(String(spec.id));
        }
        this.updateSpec()
      },
      //商品选中替换价格
      productSelection() {
        let find_spec = this.currentObj.spec.find(
          (spec) =>
          spec.spec_value_ids.includes(this.select_spec.join(','))
        );
        let spec_size = Object.keys(this.sepcOptions).length
        if (this.select_spec.length === spec_size) {
          if (find_spec) {

            this.form.product_type_code = find_spec.spec_value_ids
            this.form.order_price = find_spec.price
            this.form.product_type_name = find_spec.spec_value_str
            if (this.useRedBag) {
              this.form.order_total = (this.form.order_num * 100 * this.form.order_price - 100 * this.discountAmount) /
                100
            } else {
              this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
            }
            this.normImg = find_spec.image
            this.form.product_type_sku_img_url = find_spec.image
            this.normPrice = find_spec.price
            this.normTitle = find_spec.spec_value_str
            this.anyStock = true;
            this.buttonDisabled = false;
          } else {
            this.anyStock = false;
            this.buttonDisabled = true;
          }
        }
      },
      //确认完成支付功能
      handlePaySuccess() {
        this.buttonDisabled = false
        if (this.form.pay_source == 'wx_h5' || this.form.pay_source == 'wx_xcx') {
          let paramswx = {
            out_trade_no: this.payReuslt.order_no,
            product_code: this.currentObj.product_code
            // out_trade_no: 'pdd2024081215415010110152',
            // product_code: '10076',
          }
          getWXPayResult(paramswx).then(res => {
            this.dialogVisible = false;
            this.$notify({
              title: '支付状态',
              message: res.msg,
              duration: 3000,
              type: 'success'
            });
            this.$router.push({
              name: 'orderResult',
              query: {
                order_no: this.payReuslt.order_no,
                servicePhone: this.servicePhone
              }
            })
          })
        } else if (this.form.pay_source == 'alipay') {
          let paramsal = {
            out_trade_no: this.payReuslt.order_no,
            product_code: this.currentObj.product_code
            // out_trade_no: 'pdd2024081215415010110152',
            // product_code: '10076',
          }
          getPayResult(paramsal).then(res => {
            let objJson = JSON.parse(res.msg)
            this.dialogVisible = false;
            if (objJson.code === '10000') {
              if (objJson.trade_status == "TRADE_SUCCESS") {
                this.$notify({
                  title: '支付状态',
                  message: this.tradeStatus[objJson.trade_status],
                  duration: 3000,
                  type: objJson.trade_status == "TRADE_SUCCESS" ? 'success' : ''
                });
                this.$router.push({
                  name: 'orderResult',
                  query: {
                    order_no: this.payReuslt.order_no,
                    servicePhone: this.servicePhone
                  }
                })
              } else {
                this.$notify({
                  title: '支付状态',
                  message: '支付失败，请重新支付',
                  duration: 3000,
                  type: objJson.trade_status == "TRADE_SUCCESS" ? 'success' : ''
                });
              }
            } else {
              this.$notify({
                title: '支付状态',
                message: '支付失败，请重新支付',
                duration: 3000,
                type: objJson.trade_status == "TRADE_SUCCESS" ? 'success' : ''
              });
            }
          })
        } else {
          let YPLparams = {
            order_no: this.form.pay_source == 'efps' ? this.payReuslt.orderNo : this.payReuslt.outTradeNo
            // order_no:'pdd2024091310325151495251'
            // out_trade_no: 'pdd2024081215415010110152',
            // product_code: '10076',
          }
          getWXYPLPayResult(YPLparams).then(res => {
            this.dialogVisible = false;
            this.$notify({
              title: '支付状态',
              message: res.msg,
              duration: 3000,
              type: 'success'
            });
            this.$router.push({
              name: 'orderResult',
              query: {
                order_no: YPLparams.order_no,
                servicePhone: this.servicePhone
              }
            })
          })
        }
      },
      //鼠标移入移出控制
      changeInterval(val) {
        if (val) {
          clearInterval(this.timer)
        } else {
          this.startInterval()
        }
      },
      //轮播用
      startInterval() {
        // 事件里定时器应该先清除在设置，防止多次点击直接生成多个定时器
        clearInterval(this.timer);


        // this.timer = setInterval(() => {
        //   this.currentIndex++;
        //   if (this.currentIndex > this.carouselList.length - 1) {
        //     this.currentIndex = 0
        //   }
        // }, 3000)


      },
      // 点击控制圆点
      changeImg(index) {
        this.currentIndex = index
      },
      //随机浏览人数
      setPeople() {
        this.people = Math.floor(Math.random() * 100 + 6)
      },
      //调用数据开始
      init(ip) {
        let userAgent = navigator.userAgent;
        var ua = null;
        if (userAgent.includes('aweme')) {
          ua = true
        } else {
          ua = false
        }
        var infoType = ''
        var mobileRegex =
          /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)/;
        var mobileMatch = userAgent.match(mobileRegex);
        if (mobileMatch) {
          infoType = mobileMatch[0]
        }
        let that = this;
        this.getPageDetail(ua, infoType, userAgent)
        // getIp(ip).then(res => {
        //   const match = res.match(/\"ip\":\"([^\"]+)\"/);
        //   if (match) {
        //     this.form.order_ip_address = match[1];
        //   }
        //   let clickid = this.getRequestParam()['clickid']
        //   this.form.click_Id = clickid
        //   this.getPageDetail(ua, infoType, match[1],userAgent)

        // }, err => {
        //   this.getPageDetail(ua, infoType, match[1],userAgent)
        // })
      },
      getPageDetail(UA, Model, userAgent) {

        let tempflag = UA.toString()
        let codeId = this.getRequestParam()["code_id"]
        this.form.code_id = codeId
        let encryptCode = this.encrypt(codeId)
        this.form.sign = encryptCode
        this.form.csite = this.getRequestParam()["csite"]
        let nowTime = new Date().getTime()
        sessionStorage.setItem("time", nowTime)
        let params = {
          code_id: encryptCode,
          ua: tempflag,
          equipment_info: userAgent,
          clickid: this.getRequestParam()["clickid"],
          projectid: this.getRequestParam()["projectid"],
          csite: this.getRequestParam()["csite"]
        }
        getNotPddLanginPage(params).then(res => {
          const dataSource = JSON.parse(this.decrypt(res))
          this.currentObj = dataSource.data
          this.carouselList = this.currentObj.carousel_picture_src.split(",")
          this.detailList = this.currentObj.picture_json.split(",")
          this.normList = this.currentObj.spec
          this.form.product_code = this.currentObj.product_code
          this.form.product_name = this.currentObj.product_name
          this.form.product_type_code = this.normList[0].id
          this.form.order_price = this.normList[0].product_type_amt
          this.form.product_type_name = this.normList[0].product_type_name
          this.form.order_num = 1
          this.form.product_type_sku_img_url = this.normList[0].product_type_sku_img_url
          this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
          this.form.channel = this.currentObj.channel
          this.form.pay_source = this.source[this.currentObj.pay_type];
          this.normImg = this.normList[0].product_type_sku_img_url
          this.normPrice = this.normList[0].product_type_amt
          this.normTitle = this.normList[0].product_type_nam
          this.servicePhone = dataSource.data.customer_tel
          this.defaultImg = this.currentObj.picture_src.split(",")
          document.title = this.currentObj.title
          //单规格与多规格判断
          if (this.currentObj.is_spesc === 2) {
            this.firstSpec()
            // this.sepcFormat(res.data.spec, res.data.spec_info)
          } else {
            this.normImg = this.normList[0].product_type_sku_img_url
            this.normPrice = this.normList[0].product_type_amt
            this.normTitle = this.normList[0].product_type_nam
          }
          // this.showFlag = true;
          if (params.clickid == '__CLICKID__') {
            this.showFlag = false
          } else {
            this.showFlag = JSON.parse(dataSource.data.pass)
          }
        })

      },
      //获取url参数
      getRequestParam(key) {
        var url = window.location.href
        this.form.landingpage_link = url
        let pattern = /([^&=?]+)=([^&]+)/g; //定义正则表达式
        let parames = {}; // 定义参数对象
        url.replace(pattern, ($, $1, $2) => {
          parames[$1] = $2;
        });
        return parames;
      },
      //加密
      encrypt(text) {
        var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
        var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
        var encrypted = CryptoJS.AES.encrypt(text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
      },
      decrypt(text) {
        var key = CryptoJS.enc.Utf8.parse('1463587320654321'); //为了避免补位，直接用16位的秘钥
        var iv = CryptoJS.enc.Utf8.parse('1758326540123456'); //16位初始向量
        var encrypted = CryptoJS.AES.decrypt(text, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7

        });
        return encrypted.toString(CryptoJS.enc.Utf8);
      },
      showDialog() {
        setTimeout(() => {
          this.open = true
        }, 10);
      },
      //点击优惠券
      receive() {
        this.open = false
        this.useRedBag = true
        this.form.order_total = (this.form.order_num * 100 * this.form.order_price - 100 * this.discountAmount) / 100
        this.$nextTick(() => {
          const height = this.$refs.box.clientHeight - 1000
          window.scrollTo(0, height)
        })
      },
      //判断显示点我下单
      handleScrollx() {
        let height = window.pageYOffset
        if (height < this.showHeight) {
          this.showClickMe = true
        } else {
          this.showClickMe = false
        }
      },
      //点我下单
      clickMe() {
        this.$nextTick(() => {
          const height = this.$refs.box.clientHeight - 1000
          window.scrollTo(0, height)
        })
        this.showClickMe = false
      },
      //选择规格
      slectNorm(param) {
        this.form.product_type_code = param.id
        this.form.order_price = param.product_type_amt
        this.form.product_type_name = param.product_type_name
        if (this.useRedBag) {
          this.form.order_total = (this.form.order_num * 100 * this.form.order_price - 100 * this.discountAmount) / 100
        } else {
          this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
        }
        this.normImg = param.product_type_sku_img_url
        this.form.product_type_sku_img_url = param.product_type_sku_img_url
        this.normPrice = param.product_type_amt
        this.normTitle = param.product_type_name
      },
      //提交
      submit() {
        this.submitForm()
      },
      submitForm() {
        let that = this;
        this.form.click_num++;
        this.$refs["form"].validate(valid => {
          if (valid) {
            let phoneFlag = true
            let falseArr = [170, 171, 165, 162, 167]
            let tempNum = this.form.receiver_tel.substring(0, 3)
            for (let a = 0; a < falseArr.length; a++) {
              if (tempNum == falseArr[a]) {
                phoneFlag = false
                break;
              }
            }
            if (!phoneFlag) {
              this.$message({
                type: 'error',
                message: '请填写正确手机号'
              });
              return
            }

            if (this.currentObj.is_spesc === 2) {
              let spec_size = Object.keys(this.sepcOptions).length
              if (this.select_spec.length !== spec_size) {
                this.$message({
                  type: 'error',
                  message: '请选中完整规格'
                });
                return
              }
            }
            if (this.pass) {
              this.buttonDisabled = true
              addOrderWX(this.form).then(res => {
                this.payReuslt = res.data;
                let system = navigator.userAgent
                let isAndroid = system.indexOf('Android') > -1 || system.indexOf('Adr') > -1 // android终端
                let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
                if (isAndroid) {
                  //android终端
                  // window.open(res.data.pay_info)
                  // window.open(res.data.urlLink)
                  if (that.form.pay_source == 'efpsalipay') {
                    if (res.data.codeUrl) {
                      window.open(res.data.codeUrl)
                    } else {
                      this.$message({
                        type: 'error',
                        message: '下单失败'
                      });
                    }
                  } else {
                    if (that.form.pay_source == 'wx_xcx') {
                      window.open(res.data.url)
                    } else {
                      window.open(res.data.pay_info)
                    }
                  }
                } else if (isiOS) {
                  if (that.form.pay_source == 'efpsalipay') {
                    if (res.data.codeUrl) {
                      window.location.href = res.data.codeUrl
                    } else {
                      this.$message({
                        type: 'error',
                        message: '下单失败'
                      });
                    }

                  } else {
                    if (that.form.pay_source == 'wx_xcx') {
                      window.location.assign(res.data.url)
                      // window.location.href = res.data.url
                    } else {
                      window.location.assign(res.data.pay_info);
                      // window.location.href = res.data.pay_info
                    }
                  }
                  //ios终端
                  // window.location.href = res.data.pay_info
                  // window.location.href = res.data.urlLink
                }
                setTimeout(function() {
                  if (that.form.pay_source == 'efpsalipay') {
                    if (res.data.codeUrl) {
                      that.dialogVisible = true
                    } else {
                      that.dialogVisible = false
                    }
                  } else {
                    that.dialogVisible = true
                  }
                }, 2000);
                // this.buttonDisabled = false
              }, err => {
                this.buttonDisabled = false
              })
            } else {
              this.buttonDisabled = true
              addOrderWX(this.form).then(res => {
                this.payReuslt = res.data;
                let system = navigator.userAgent
                let isAndroid = system.indexOf('Android') > -1 || system.indexOf('Adr') > -1 // android终端
                let isiOS = !!system.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
                if (isAndroid) {
                  //android终端
                  // window.open(res.data.pay_info)
                  // window.open(res.data.urlLink)
                  if (that.form.pay_source == 'efpsalipay') {
                    if (res.data.codeUrl) {
                      window.open(res.data.codeUrl)
                    } else {
                      this.$message({
                        type: 'error',
                        message: '下单失败'
                      });
                    }
                  } else {
                    if (that.form.pay_source == 'wx_xcx') {
                      window.open(res.data.url)
                    } else {
                      window.open(res.data.pay_info)
                    }
                  }
                } else if (isiOS) {
                  if (that.form.pay_source == 'efpsalipay') {
                    if (res.data.codeUrl) {
                      window.location.href = res.data.codeUrl
                    } else {
                      this.$message({
                        type: 'error',
                        message: '下单失败'
                      });
                    }
                  } else {
                    if (that.form.pay_source == 'wx_xcx') {
                      window.location.assign(res.data.url)
                      // window.location.href = res.data.url
                    } else {
                      window.location.assign(res.data.pay_info);
                      // window.location.href = res.data.pay_info
                    }
                  }
                  //ios终端
                  // window.location.href = res.data.pay_info
                  // window.location.href = res.data.urlLink
                }
                setTimeout(function() {
                  if (that.form.pay_source == 'efpsalipay') {
                    if (res.data.codeUrl) {
                      that.dialogVisible = true
                    } else {
                      that.dialogVisible = false
                    }
                  } else {
                    that.dialogVisible = true
                  }
                }, 2000);
                // this.buttonDisabled = false
              }, err => {
                this.buttonDisabled = false
              })
              // if(this.ipAddress.indexOf(this.form.receiver_area[1])!==-1){

              // }else{
              //   this.buttonDisabled=false
              //   this.messageOpen=true
              // }
            }
          }
        });
      },
      //购买数量
      changeNum() {
        if (this.form.product_type_code) {
          if (this.useRedBag) {
            this.form.order_total = (this.form.order_num * 100 * this.form.order_price - this.discountAmount * 100) /
              100
          } else {
            this.form.order_total = this.form.order_num * 100 * this.form.order_price / 100
          }
        }
      },
      //定位最下面
      gotobottom() {
        this.$nextTick(() => {
          const height = this.$refs.box.clientHeight - 1000
          window.scrollTo(0, height)
        })
      },
      //切换tab
      changeTab1() {
        this.acitve = true
        this.changeHeight()
      },
      changeTab2() {
        this.acitve = false
        this.changeHeight()
      },
      changeHeight() {
        setTimeout(() => {
          let clientH = window.innerHeight || document.documentElement.clientHeight;
          let boxHeight = this.$refs.box.offsetHeight
          let orderInfoHeight = 0
          if (this.$refs.orderInfo) {
            orderInfoHeight = this.$refs.orderInfo.offsetHeight
          }
          let showHeight = boxHeight - orderInfoHeight - clientH
          this.showHeight = showHeight
        }, 500);
      },
    }
  }
</script>

<style scoped>
  .maxwidht {
    max-width: 500px;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .padding {
    padding: 10px;
  }

  .paddingtb {
    padding: 10px 0;
  }

  .paddinglr {
    padding: 0 10px;
  }

  .bgcolor {
    background-color: #f7f7f7;
  }

  .carousel img {
    width: 100%;
  }

  .baseInfo {
    padding: 20px 10px 0px 10px;
    background: white;
  }

  .flexMoney {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #f85959;
  }

  .money {
    font-size: 30px;
    font-weight: 600;

  }

  .desc {
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #333;
    line-height: 30px;
    margin: 8px 0;
  }

  .freeFlex {
    display: flex;
    /* justify-content: space-around; */
    height: 44px;
    line-height: 44px;
    text-align: center;
  }

  .baoyou {
    width: 130px;
    background: #ffe0df;
    border-radius: 5px 0 0 5px;
  }

  .cartDiv {
    width: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .cart {
    width: 25px;
    animation-duration: 0.8s;
    animation-timing-function: ease;
    animation-delay: 0s;
    animation-iteration-count: infinite;
    animation-direction: normal;
    animation-fill-mode: none;
    animation-play-state: running;
    animation-name: cart;
  }

  @keyframes cart {
    from {
      transform: scale(0.8);
    }

    to {
      transform: scale(1);
    }
  }

  .pay {
    background-image: url("../assets/bg-right.png");
    background-size: 100% 100%;
    flex: 1;
    margin-left: -10px;
    color: white;
  }

  .service {
    margin-top: 10px;
    border-top: 1px solid #f3f3f3;
    padding: 10px 0;
    line-height: 20px;

  }

  .service span {
    color: #999;
    font-size: 12px;
    margin: 0 10px;
  }

  .service i {
    margin-right: 4px;
    color: red;
  }

  .safeguard {
    margin-left: 46px !important;
  }

  .scanNum {
    font-weight: 600;
    font-size: 18px;
    height: 50px;
    line-height: 50px;
  }

  .scanNum span {
    color: #999;
    font-size: 12px;
  }

  .scandiv {
    background: #f85959;
  }

  .sacnContainer {
    height: 160px;
    overflow: hidden;
  }

  .unit {
    display: flex;
    padding: 4px 10px;
    border-bottom: 1px solid #e5e5e5;
  }

  .avatar {
    width: 60px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .personinfo {
    width: 70%;
    margin-right: 10px;
    font-size: 14px;
  }

  .namephone {
    font-weight: 600;
    font-size: 16px;
  }

  .tobuy {
    width: 70px;
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    text-align: center;
    background: #fe2448;
    color: white;
    margin-top: 10px;
  }

  .tabs {
    display: flex;
    justify-content: space-around;
    background: white;
    height: 50px;
    line-height: 50px;
  }

  .activetab {
    color: #e95560;
    border-bottom: 2px solid #e95560;
  }

  .pictext {
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #999
  }

  .detailimg {
    width: 100%;
    display: flex;
  }

  .commonstyle>>>.el-collapse-item__header {
    font-size: 16px !important;
  }

  .explaintext {
    font-size: 16px;
    color: #999;
  }

  .orderInfo {
    font-weight: 600;
    text-align: center;
    padding-top: 30px;
  }

  .border {
    border-bottom: 1px solid #e5e5e5;
  }

  .orderFlex {
    display: flex;
  }

  .orderimg {
    width: 100px;
    height: 100px;
    margin-right: 20px;
  }

  .orderMoney {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .normunit {
    padding: 10px;
    border: 1px solid #e95560;
    border-radius: 6px;
    margin: 10px 0;
  }

  .realPay {
    color: #e95560;
    font-size: 20px;
    font-weight: 600;
  }

  .red {
    color: #e95560
  }

  .buynumflex {
    display: flex;
    justify-content: space-between;
  }

  .buynum {
    line-height: 40px;
  }

  .commonstyle>>>.el-form-item {
    margin-bottom: 16px;
    font-size: 16px;
    border-bottom: 1px solid #e5e5e5;
  }

  .commonstyle>>>.el-form-item__label {
    font-size: 16px;
  }

  .commonstyle>>>.el-input__inner {
    border: none !important;
  }

  .commonstyle>>>.el-form-item__error {
    padding-left: 16px;
  }

  .commonstyle {
    margin-top: 10px;
    padding: 10px;
    background: white;
  }

  .payicon {
    width: 20px;
    margin-right: 4px;
  }

  .paycontainer {
    display: flex;
  }

  .payflex {
    display: flex;
    margin-top: 20px;
    justify-content: space-between;
    align-items: center;
  }

  .conmonheight {
    height: 40px;
    line-height: 40px;
  }

  .border {
    border-bottom: 1px solid #e5e5e5;
  }

  .messageflex {
    display: flex;
    width: 100%;
  }

  .remark {
    height: 40px;
    line-height: 40px;
    margin-right: 20px;
  }

  .button {
    width: 98%;
    margin: 40px auto 0;
    color: white;
    background: #f85959;
    height: 50px;
    font-size: 18px;
  }

  .buton2 {
    width: 100%;
    max-width: 500px;
    position: fixed;
    bottom: 0;
    color: white;
    background: #f85959;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 4px;
    z-index: 1000000;
  }

  .activeradio {
    background: #f85959;
    color: white !important;
    line-height: 30px;
    border-radius: 6px;
  }

  .deactiveradio {
    color: #333;
    line-height: 30px;
    border-radius: 6px;
  }

  .defaultImg {
    width: 100%;
    display: flex;
  }

  .nothing {
    text-align: center;
    margin-top: 20%;
  }

  .nothing img {
    width: 200px;
  }

  .center {
    text-align: center;
  }

  .dialog>>>.el-dialog {
    background: none;
    position: relative;
    margin: 0 auto 50px;
    background: none;
    width: 50%;
    box-shadow: none
  }

  .bagcontent {
    background-image: url("../assets/redbag.png");
    background-size: 100% 100%;
    text-align: center;
    color: #dd5300;
    font-size: 30px;
    font-weight: 600;
    height: 250px;
  }

  .minusmoney {
    padding-top: 60px
  }

  .messageDialog {
    margin-top: 25vh;
  }

  .confirm {
    width: 100%;
    margin-top: 20px;
    background: #f85959;
    color: white;
    height: 40;
    line-height: 40px;
    text-align: center;
  }




  /* 清除li前面的圆点 */
  li {
    list-style-type: none;
  }

  .showImg {
    position: relative;
    height: 250px;
    margin: 0 auto;
    overflow: hidden;
  }

  /* 轮播图片 */
  .showImg img {
    width: 100%;
    height: 100%;
  }

  /* 箭头图标 */
  .iconDiv {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 30px;
    height: 30px;
    border: 1px solid #666;
    border-radius: 15px;
    background-color: rgba(125, 125, 125, .2);
    line-height: 30px;
    text-align: center;
    font-size: 25px;
    cursor: pointer;
  }

  .iconDiv:hover {
    background-color: white;
  }

  .icon-left {
    left: 10px;
  }

  .icon-right {
    right: 10px;
  }

  /* 控制圆点 */
  .banner-circle {

    position: absolute;
    bottom: 0;
    width: 100%;
    /* height: 20px; */
  }

  .banner-circle ul {
    /* margin: 0 50px; */
    height: 100%;
    text-align: right;
  }

  .banner-circle ul li {
    display: inline-block;
    width: 14px;
    height: 14px;
    margin: 0 5px;
    border-radius: 7px;
    background-color: rgba(125, 125, 125, .8);
    cursor: pointer;
  }

  .active {
    background-color: black !important;
  }

  .button_shadow {
    max-width: 500px;
    width: 100%;
    line-height: 80px;
    position: fixed;
    bottom: 0;
    border: none;
    font-size: 20px;
    font-weight: bold;
    color: white;
    text-align: center;
    background-image: url('../assets/btn.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .spec_item {
    position: relative;
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    margin-top: 10px;
    border-radius: 6px;
  }

  .spec_item img {
    width: 50px;
    border-radius: 6px 0px 0px 6px;
  }

  .spec-container {
    display: flex;
    flex-wrap: wrap;
  }

  .margin-right {
    margin-right: 10px;
  }

  .margin-left {
    margin-left: 10px;
  }

  .padding-sm {
    padding: 5px 15px;
  }

  .paddingtb {
    padding: 20px;
  }

  .sel_red {
    border: 1px solid red;
    color: red;
  }

  .stock {
    border: 1px solid;
  }

  .wu_huo {
    position: absolute;
    font-size: 10px;
    top: -8px;
    right: -12px;
    background-color: #d0d0d0;
    padding: 3px;
    border-radius: 6px 6px 6px 0px;
  }

  .wechat {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 55px;
  }

  .wechat img {
    width: 20px;
    height: 20px;
  }

  .text-center {
    text-align: center;
  }

  .margin-top {
    margin-top: 30px;
  }

  .padding-xl {
    padding: 20px;
  }
</style>
<style>
  .el-cascader-menu {
    max-width: 130px !important;
    min-width: 130px !important;
  }

  .el-radio__label {
    display: none !important;
    /* 隐藏label文本 */
  }
</style>



// WEBPACK FOOTER //
// src/components/sweet.vue